<template>
	<div class="vstack gap-5">
		<table class="table table-sm">
			<tbody>
				<tr v-if="sale.number">
					<td class="px-1 text-sm fw-bold">Número</td>
					<td class="px-1 text-sm text-end">{{ sale.number }}</td>
				</tr>
				<tr v-if="sale.company">
					<td class="px-1 text-sm fw-bold">Empresa</td>
					<td class="px-1 text-sm text-end">{{ sale.company.name }}</td>
				</tr>
				<tr v-if="sale.customer">
					<td class="px-1 text-sm fw-bold">Cliente</td>
					<td class="px-1 text-sm text-end">{{ sale.customer.name }}</td>
				</tr>
				<tr v-if="dateFormatted">
					<td class="px-1 text-sm fw-bold">Fecha</td>
					<td class="px-1 text-sm text-end">{{ dateFormatted }}</td>
				</tr>
				<tr v-if="sale.amount">
					<td class="px-1 text-sm fw-bold">Total</td>
					<td class="px-1 text-sm text-end">{{ vueNumberFormat(sale.amount, { suffix: ` ${sale.currency}`, precision: 2 }) }}</td>
				</tr>
				<tr v-if="sale.amount">
					<td class="px-1 text-sm fw-bold">Total sin impuestos</td>
					<td class="px-1 text-sm text-end">{{ vueNumberFormat(sale.amount_net, { suffix: ` ${sale.currency}`, precision: 2 }) }}</td>
				</tr>
				<tr v-if="sale.discount">
					<td class="px-1 text-sm fw-bold">Descuento total</td>
					<td class="px-1 text-sm text-end">
						<span class="d-inline-block text-danger fw-bold">{{ vueNumberFormat(sale.discount_percentage, { suffix: ` %`, precision: 2 }) }}</span>
						<span class="d-inline-block ps-2">{{ vueNumberFormat(sale.discount, { suffix: ` ${sale.currency}`, precision: 2 }) }}</span>
					</td>
				</tr>
				<tr v-if="sale?.pivot?.transaction">
					<td class="px-1 text-sm fw-bold">Comisión</td>
					<td class="px-1 text-sm text-end">{{ vueNumberFormat(sale.pivot.transaction.amount, { suffix: ` ${sale.currency}`, precision: 2 }) }}</td>
				</tr>
			</tbody>
		</table>
		<table class="table table-sm">
			<thead>
				<tr class="fw-bold">
					<td class="px-1 text-sm">Detalles de productos</td>
					<td class="px-1 text-sm text-end">Cant.</td>
					<td class="px-1 text-sm text-end">Monto</td>
				</tr>
			</thead>
			<tbody>
				<template v-if="sale.products.length > 0">
					<tr class="lh-sm align-top" v-for="(product, index) in sale.products" v-bind:key="index">
						<td class="px-1 text-sm vstack">
							<b>{{ product.name }}</b>
							<small class="text-muted" v-if="product.extras?.code"><b>Código:</b> {{ product.extras.code }}</small>
							<small class="text-muted" v-if="product.pivot?.attributes?.color"><b>Color:</b> {{ product.pivot.attributes.color }}</small>
							<small class="text-muted" v-if="product.pivot?.attributes?.size"><b>Medida:</b> {{ product.pivot.attributes.size }}</small>
						</td>
						<td class="px-1 text-sm text-end">{{ product.pivot.quantity }}</td>
						<td class="px-1 text-sm text-end">
							<span class="d-inline-block text-nowrap">{{ vueNumberFormat((product.pivot.amount * product.pivot.quantity), { suffix: ` ${sale.currency}`, precision: 2 }) }}</span>
						</td>
					</tr>
				</template>
				<template v-else>
					<tr>
						<td colspan="3" class="px-1 text-sm">No hay productos.</td>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>

<script>
	import { computed } from 'vue';
	import moment from 'moment';

	export default {
		props: {
			sale: Object
		},
		setup(props) {
			const dateFormatted = computed(() => moment(props.sale?.computed_at).format('LLL'));

			return { dateFormatted };
		}
	}
</script>